import React, { FC } from "react";
import { FormBaseType, UserRole } from "@green0meter/api-client";

import {
  BuyersHubWelcomeBanner,
  BuyersHubGuide,
  BuyersHubReports,
  BuyersHubDashboard,
  BuyersHubSuppliers,
  BuyersHubInvite,
} from "@components/main/procurement";
import { Box, Grid } from "@components/base";
import { useUserStore } from "@store/user";

const BuyersHubPage: FC = () => {
  const { user } = useUserStore();
  const canManageSuppliers =
    user?.role !== UserRole.Viewer && user?.role !== UserRole.Auditor;
  const isNotViewer = user?.role !== UserRole.Viewer;

  return (
    <Box>
      <Grid container spacing={3}>
        <BuyersHubWelcomeBanner />
        {canManageSuppliers && (
          <Grid size={12}>
            <BuyersHubGuide />
          </Grid>
        )}
        {canManageSuppliers && (
          <Grid size={12}>
            <BuyersHubInvite />
          </Grid>
        )}
        {isNotViewer && (
          <Grid size={12}>
            <BuyersHubSuppliers />
          </Grid>
        )}
        <Grid size={12}>
          <BuyersHubDashboard />
        </Grid>
        <Grid size={12}>
          <BuyersHubReports formBaseType={FormBaseType.ProcurementSupplier} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default BuyersHubPage;
